import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-refresh.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-8265bb22")

_pushScopeId("data-v-8265bb22")
const _hoisted_1 = { class: "ticket-view" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "工单视图", -1)
const _hoisted_3 = { class: "ticket-view-nav-tabs-box" }
const _hoisted_4 = {
  key: 0,
  class: "nav-selector-wrap"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "未匹配", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "待认领", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "处理中", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "已挂起", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "已解决", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "全部", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "待认领", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "处理中", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "已挂起", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "已解决", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_25 = { class: "body" }
const _hoisted_26 = { class: "content-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb, null, {
      default: _withId(() => [
        _hoisted_2,
        _createVNode("img", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
          class: ["btn-refresh", {
          loading: _ctx.refreshing
        }],
          src: _imports_0
        }, null, 2)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      (_ctx.isAdministrator)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_el_select, {
              onVisibleChange: _ctx.optionsVisibleChange,
              "popper-class": "nav-select-options",
              class: "nav-select",
              onChange: _ctx.navTabsFlagChanged,
              modelValue: _ctx.navTabsFlag,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.navTabsFlag = $event)),
              placeholder: "请选择"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_option, {
                  label: "管理员",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "个人",
                  value: 2
                })
              ]),
              _: 1
            }, 8, ["onVisibleChange", "onChange", "modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_tabs, {
        class: "ticket-view-nav-tabs",
        modelValue: _ctx.activeTabName,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTabName = $event)),
        onTabClick: _ctx.handleClickTabName
      }, {
        default: _withId(() => [
          (_ctx.navTabsFlag === 1)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                name: "紧急工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_5,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.allUnusualTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 1)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                name: "所有待认领工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_7,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.allUnassignedTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 1)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 2,
                name: "所有待处理工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_9,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.allPendingTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_10
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 1)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 3,
                name: "所有已挂起工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_11,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.allSuspendedTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_12
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 1)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 4,
                name: "所有已完成工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_13,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.allClosedTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_14
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 2)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 5,
                name: "所有工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_15,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.personalAllTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_16
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 2)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 6,
                name: "待认领工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_17,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.personalUnassignedTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_18
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 2)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 7,
                name: "待处理工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_19,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.personalPendingTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_20
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 2)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 8,
                name: "已挂起工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_21,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.personalSuspendedTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_22
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.navTabsFlag === 2)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 9,
                name: "已完成工单"
              }, {
                label: _withId(() => [
                  _createVNode("div", null, [
                    _hoisted_23,
                    _createVNode("span", null, " (" + _toDisplayString(_ctx.ticketCount.personalClosedTicketCount) + ")", 1)
                  ])
                ]),
                default: _withId(() => [
                  _hoisted_24
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _createVNode(_component_router_view, null, {
          default: _withId(({ Component }) => [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withId(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { ref: "child" }, null, 512))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ])
    ])
  ]))
})